import { Component, OnInit, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { ImageEditorComponent } from '../image-editor/image-editor.component'

@Component({
  selector: 'app-t-discover',
  templateUrl: './t-discover.component.html',
  styleUrls: ['./t-discover.component.css']
})
export class TDiscoverComponent extends GeneralTeacherComponent {

  @ViewChildren('hintImage') images: QueryList<ImageEditorComponent>;
  @ViewChild('requiredImage', {static: true}) requiredImage: ImageEditorComponent;

  hints: any[] = [{}, {}];
  image: string[][];
  requiredText: string;
  tipCount = 2;

  colors: string;

  constructor(protected topicsService: TopicService, protected activatedRoute: ActivatedRoute) {
    super(topicsService, activatedRoute);
    this.type = "discover";
    this.title = this.get("discover");
  }

  public ngAfterViewInit(): void {
    this.images.forEach(e => e.initImage());

    this.images.forEach((e, i) => {
      if (this.hints[i].image) {
        e.setImage(this.hints[i].image)
      }
    });

  }


  /** sets information based on configuration */
  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.hints = this.configuration.typespecifics.hints;
    this.image = this.configuration.typespecifics.required;
    this.tipCount = this.hints.length;

    if (this.image.map(v => v.filter(u => u == "w")).filter(u => u.length > 0).length > 0) {
      this.colors = "bw";
    } else if (this.hints.filter(v => v.image.filter(v => v.filter(u => u == "w").filter(v => v.length > 0).length > 0).length > 0).length > 0) {
      this.colors = "bw";
    } else {
      this.colors = "cmyrgb";
    }

    this.requiredImage.initImage();
    if (this.image) {
      this.requiredImage.setImage(this.image);
    }


  }

  generateDefinition() {
    let definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = "./assets/images/discover.png";
    definition.level = 3;
    definition.key = "compression%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics = {};
    definition.typespecifics.required = this.requiredImage.getImage();
    definition.typespecifics.hints = this.hints;
    this.image = this.requiredImage.getImage();
    definition.key = definition.key.concat("%", this.image.toString());
    return definition;
  }

  /** add a new hint */
  incrementTip() {
    this.tipCount++;
    this.hints.push({});
  }

  /** remove the given hint */
  deleteHint(i: number) {
    this.hints.splice(i, 1);
    this.tipCount--;
  }

  /** compute the text for the given image */
  computeText(i: number) {
    let solution = "";
    //compute solution
    let imageString = "";
    if (i >= 0) {
      imageString = this.hints[i].image.map(v => v.join("")).join("");
    } else {
      imageString = this.image.map(v => v.join("")).join("");
    }
    let lastSign = "";
    let count = 0;
    for (let c of imageString) {
      if (c == lastSign) {
        count++;
      } else {
        if (count > 0) {
          solution = solution.concat(count.toString(), lastSign);
        }
        lastSign = c;
        count = 1;
      }
    }
    solution = solution.concat(count.toString(), lastSign);

    if (i >= 0) {
      this.hints[i].text = solution;
    } else {
      this.requiredText = solution;
    }

  }

  reset() {
    super.reset();
    this.title = this.get("discover");
    this.colors = "bw";
    this.requiredImage.initImage();
    this.images.forEach(e => e.initImage());
    this.hints = [{}, {}];
    this.tipCount = 2;
    this.requiredText = "";
  }

}
